import React from 'react';
import Widget from '../../components/Widget';
import { IClassNames } from '../../hooks/classNames.hooks';
import { AccessKeyOverview } from '../AccessKeys';

interface AccessKeysWidgetProps extends IClassNames {}

const AccessKeysWidget: React.FC<AccessKeysWidgetProps> = ({ ...props }) => {
  return (
    <Widget
      title="accessKeys.overview.title"
      description="accessKeys.overview.description"
      unstyled
      {...props}
    >
      <AccessKeyOverview />
    </Widget>
  );
};

export default AccessKeysWidget;
